.form-box {
  margin: 20px;
}
.form-box label {
  width: 200px;
  display: inline-block;
}
.form-box ix-input,ix-upload {
  width: 400px;
}
